import React from "react";
import { createPortal } from "react-dom";
import { getStatusVisual } from "../../../../utils/candidatesV2Constants";
import { calcMenuPos } from "../constants";

// Hiring status pill + portal menu of the other statuses. Picking one calls
// onPick(status, currentName) so the parent can ask for the mandatory comment.
const HiringStatusCell = ({ currentName, hiringStatuses, isOpen, menuPos, onOpen, onClose, onPick, loading, disabled }) => {
  if (loading) return <div className="spinner-border" style={{ width: "1rem", height: "1rem", color: "#F75891" }} />;

  const cfg = getStatusVisual(currentName);
  const selectableStatuses = hiringStatuses.filter((s) => s.name !== currentName);

  const toggle = (e) => {
    if (isOpen) onClose();
    else onOpen(calcMenuPos(e.currentTarget, { width: 150, height: 220 }));
  };

  return (
    <div className="status-dropdown-v2">
      <button
        className="status-dd-btn"
        style={{ color: cfg.color, background: cfg.bg, borderColor: cfg.border }}
        onClick={toggle}
        disabled={disabled}
      >
        <span style={{ width: 7, height: 7, borderRadius: "50%", background: cfg.color, flexShrink: 0, display: "inline-block" }} />
        {cfg.label}
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" style={{ marginLeft: 2 }}>
          <path d="M2 3.5L5 6.5L8 3.5" stroke={cfg.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      {isOpen && menuPos && createPortal(
        <div className="status-dd-menu" style={{ position: "fixed", left: menuPos.left, top: menuPos.top, bottom: menuPos.bottom, zIndex: 9999 }}>
          {selectableStatuses.length === 0 ? (
            <div className="status-dd-empty">No other statuses available</div>
          ) : (
            selectableStatuses.map((s) => {
              const optCfg = getStatusVisual(s.name);
              return (
                <button key={s.id} className="status-dd-item" onClick={() => { onPick(s, currentName); onClose(); }}>
                  <span style={{ width: 8, height: 8, borderRadius: "50%", background: optCfg.color, flexShrink: 0 }} />
                  <span>{optCfg.label}</span>
                </button>
              );
            })
          )}
        </div>,
        document.body
      )}
    </div>
  );
};

export default HiringStatusCell;
